module.exports = __webpack_public_path__ + "static/img/bg-banner-tec.c6e6d1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg-banner-tec.png
// module id = 3Py1
// module chunks = 1